import React from 'react';
import { string, func } from 'prop-types';

import Input from '~components/Input';
import Field from '~components/Field';

import styles from './styles.module.scss';

const LoginInput = ({ label, type, containerStyle, ...props }) => (
  <div className={containerStyle}>
    <label className={`m-left-1 text-base regular ${styles.label}`}>{label}</label>
    <Field type={type} component={Input} {...props} inputStyle={`full-width m-top-2 ${styles.input}`} />
  </div>
);

LoginInput.propTypes = {
  name: string.isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
  containerStyle: string,
  label: string,
  placeholder: string,
  type: string
};

export default LoginInput;
